import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { i18nextPlugin } from "translation-check";
import LanguageDetector from "i18next-browser-languagedetector";

import general_en from "./en/general";
import components_en from "./en/components";
import animal_en from "./en/animal";
import land_en from "./en/land";

import general_es from "./es/general";
import components_es from "./es/components";
import animal_es from "./es/animal";
import land_es from "./es/land";

const resources = {
  en: {
    translation: {
      ...general_en,
      ...components_en,
      ...animal_en,
      ...land_en,
    },
  },
  es: {
    translation: {
      ...general_es,
      ...components_es,
      ...animal_es,
      ...land_es,
    },
  },
};

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // Manage translations
  .use(i18nextPlugin)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    // lng: navigator.language,
    // debug: true,
    fallbackLng: "es",
    resources,
  });
